import React from 'react';
import { AudioButton } from '../AudioButton';
import { MicrophoneButton } from '../MicrophoneButton';
import { toast } from 'sonner';

export const PracticeButton = ({ text }) => {
  const handleTranscription = (transcribedText) => {
    if (transcribedText) {
      toast.info(`You said: "${transcribedText}"`);
    }
  };

  return (
    <div className="inline-flex items-center gap-1">
      <AudioButton text={text} size="sm" voice="nova" />
      <MicrophoneButton
        size="sm"
        expectedText={text}
        onTranscription={handleTranscription}
        onPronunciationScore={() => {}}
      />
    </div>
  );
};
